export function nextOptionIndex(key, currentIndex, optionCount) {
    if (optionCount < 1) return -1;

    if (key === 'Home') return 0;
    if (key === 'End') return optionCount - 1;
    if (key === 'ArrowDown') return currentIndex < optionCount - 1 ? currentIndex + 1 : 0;
    if (key === 'ArrowUp') return currentIndex > 0 ? currentIndex - 1 : optionCount - 1;

    return currentIndex;
}

export function focusVerificationError(messageKey, phoneInput, codeInput) {
    const target = messageKey === 'number' ? phoneInput : (messageKey === 'code' ? codeInput : null);
    if (target) target.focus();
}

export function createCountryListbox(config) {
    const state = {
        options: [],
        activeIndex: -1,
    };

    function panelOpen() {
        return !config.panel.classList.contains('hidden');
    }

    function setActiveIndex(index, scrollIntoView) {
        const optionElements = config.list.querySelectorAll('[role="option"]');
        state.activeIndex = index >= 0 && index < optionElements.length ? index : -1;

        optionElements.forEach(function (option, optionIndex) {
            option.classList.toggle('bg-sky-50', optionIndex === state.activeIndex);
            option.classList.toggle('dark:bg-sky-950/40', optionIndex === state.activeIndex);
        });

        const activeOption = optionElements[state.activeIndex];
        if (!activeOption) {
            config.search.removeAttribute('aria-activedescendant');
            return;
        }

        config.search.setAttribute('aria-activedescendant', activeOption.id);
        if (scrollIntoView) activeOption.scrollIntoView({ block: 'nearest' });
    }

    function close(returnFocus) {
        config.setHidden(config.panel, true);
        config.button.setAttribute('aria-expanded', 'false');
        config.search.setAttribute('aria-expanded', 'false');
        config.search.removeAttribute('aria-activedescendant');
        if (returnFocus) config.button.focus();
    }

    function select(index) {
        const country = state.options[index];
        if (!country) return;

        config.onSelect(country);
        close(false);
        config.phoneInput.focus();
    }

    function render(term) {
        const needle = String(term || '').trim().toLowerCase();
        const digits = needle.replace(/[^\d]/g, '');
        const matches = config.countries.filter(function (country) {
            if (!needle) return true;
            if (country.name.toLowerCase().includes(needle)) return true;

            return Boolean(digits) && country.dial.startsWith(digits);
        });

        config.list.textContent = '';
        state.options = matches;
        matches.forEach(function (country, index) {
            config.list.appendChild(config.createOption(country, function () {
                select(index);
            }));
        });

        config.setHidden(config.empty, matches.length > 0);
        const selectedIndex = matches.findIndex(function (country) {
            return country.iso === config.getSelectedIso();
        });
        setActiveIndex(selectedIndex >= 0 ? selectedIndex : (matches.length ? 0 : -1), false);
    }

    function open(activeIndex) {
        config.search.value = '';
        render('');
        config.setHidden(config.panel, false);
        config.button.setAttribute('aria-expanded', 'true');
        config.search.setAttribute('aria-expanded', 'true');
        if (typeof activeIndex === 'number') setActiveIndex(activeIndex, true);
        config.search.focus();
    }

    config.button.addEventListener('click', function () {
        if (panelOpen()) {
            close(false);
            return;
        }

        open();
    });

    config.button.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;

        event.preventDefault();
        open(event.key === 'ArrowUp' ? config.countries.length - 1 : 0);
    });

    config.search.addEventListener('input', function () {
        render(config.search.value);
    });

    config.search.addEventListener('keydown', function (event) {
        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
            event.preventDefault();
            setActiveIndex(nextOptionIndex(event.key, state.activeIndex, state.options.length), true);
            return;
        }

        if (event.key === 'Enter') {
            event.preventDefault();
            select(state.activeIndex);
            return;
        }

        if (event.key === 'Escape') {
            event.preventDefault();
            close(true);
        }
    });

    config.documentTarget.addEventListener('click', function (event) {
        if (!panelOpen() || config.wrapper.contains(event.target)) return;
        close(false);
    });

    config.documentTarget.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && panelOpen()) close(true);
    });

    return { close, open, panelOpen, render, state };
}
